import { FC } from "react";
import { Box, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { TooltipProps } from "recharts";
import { NameType, ValueType } from "recharts/types/component/DefaultTooltipContent";
import { formatNumber } from "../../../../../common/utils";
import { MeasurableValueDTO } from "../../../../../datasources/api-client/data-contracts";
import { ThemeColors } from "../../../../../theme/themeValues";

interface ExtraProps {
	total?: MeasurableValueDTO;
}

interface PayloadEntry extends MeasurableValueDTO {
	name: string;
	color: string;
	waterfallRange: number[];
}

type Props = TooltipProps<ValueType, NameType> & ExtraProps;

const CustomTooltip: FC<Props> = ({ active, payload, label, total }) => {
	const { t } = useTranslation("common");

	const isVisible = active && payload && payload.length > 0;
	if (!isVisible) return null;

	return (
		<Box
			sx={{
				backgroundColor: ThemeColors.LightBackground,
				border: "1px solid black",
				borderRadius: "5px",
				boxShadow: 1,
			}}
			p={1}
		>
			<Typography variant="caption" fontWeight={700} style={{ color: ThemeColors.DarkContrastText }}>
				{label}
			</Typography>

			<Stack spacing={1} mt={1}>
				{payload.map((p, index) => {
					const entry = p.payload as PayloadEntry;
					return (
						<Stack
							spacing={2}
							key={index}
							direction="row"
							justifyContent="space-between"
							alignItems="center"
						>
							<Stack direction="row" alignItems="center" spacing={0.5}>
								<Typography variant="caption" style={{ color: ThemeColors.DarkContrastText }}>
									{entry.value > 0 ? t("increase") : t("decrease")}
								</Typography>
							</Stack>

							<Typography variant="caption" style={{ color: ThemeColors.DarkContrastText }}>
								{formatNumber(entry.value ?? 0, "decimal", 2, 2)} {entry.measure}
							</Typography>
						</Stack>
					);
				})}
			</Stack>
		</Box>
	);
};

export default CustomTooltip;
